import Entity from '../../../../../../foundation/domain/Entity';
import EntityId from '../../../../../../foundation/domain/EntityId';
import User from '../../../../users/domain/aggregates/user/User';
import Exercise from '../exercise/Exercise';
import Timepoint from '../../../../../../foundation/time/Timepoint';
import Duration from '../../../../../../foundation/time/Duration';

export default class ExerciseResult extends Entity<ExerciseResult> {

	public constructor (id: EntityId<ExerciseResult>, private createdTimepoint: Timepoint, private userId: EntityId<User>, private exerciseId: EntityId<Exercise>, private step: number, private value: string, private correct: boolean, private nextTimepoint: Timepoint) {
		super(id);
	}

	public getCreatedTimepoint () {
		return this.createdTimepoint;
	}

	public getUserId () {
		return this.userId;
	}

	public getExerciseId () {
		return this.exerciseId;
	}

	public getStep () {
		return this.step;
	}

	public getValue () {
		return this.value;
	}

	public isCorrect () {
		return this.correct;
	}

	public getNextTimepoint () {
		return this.nextTimepoint;
	}

	public isLevel0 () {
		return this.createdTimepoint.plus(Duration.seconds(30)).equals(this.nextTimepoint);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/domain/aggregates/exerciseResult/ExerciseResult.ts